import { World } from './world';
import type { FeedEvent } from '../shared/protocol';

export interface CRobot {
  id: number; cls: number; name: string; born: number;
  x: number; y: number; fx: number; fy: number; tx: number; ty: number; t0: number;
  st: number; left: boolean; carry: number; bat: number; seen: boolean; step: number;
  owner?: string; demo?: boolean;
}
export interface Particle { x: number; y: number; vx: number; vy: number; life: number; max: number; col: string; g: number }
export type Sel = { kind: 'robot'; id: number } | { kind: 'chamber'; id: number } | { kind: 'deposit'; id: number } | { kind: 'rock'; x: number; y: number } | null;

export const S = {
  world: new World(),
  robots: new Map<number, CRobot>(),
  stats: null as any, ops: [] as any[], chambers: [] as any[], events: [] as FeedEvent[], blocks: [] as any[],
  discoveries: [] as any[], known: new Set<number>(), breached: new Set<number>(), skillLog: [] as any[], layers: [] as any[],
  det: null as any, sel: null as Sel, follow: false,
  cam: { x: 0, y: 0, s: 2, tx: null as number | null, ty: null as number | null },
  connected: false, frameDt: .2, lastFrame: 0, created: 0,
  parts: [] as Particle[],
  doors: new Map<number, number>(),
  hover: null as null | { x: number; y: number },
};
